// Copyright (c) 2026 Riddle, LLC. All rights reserved.
// Author: Ray Harris

import { useCallback } from "react";

import { useAuthSession } from "../../../hooks/useAuthSession";
import { currentRouteUrl } from "../../../router/navigation";
import { rememberReturnTo } from "../../../routes/returnTo";
import { logAuthFailure } from "../../../utils/authDiagnostics";

export function useSignInAgain(): () => void {
  const { login } = useAuthSession();
  return useCallback(() => {
    rememberReturnTo(currentRouteUrl());
    Promise.resolve(login()).catch((error: unknown) => {
      logAuthFailure("sign-in-again-failed", error);
    });
  }, [login]);
}
